import React from "react";

const PiePagina = ()=>{
    return (
        // <footer className="d-flex flex-wrap justify-content-between align-items-center py-3 my-4 border-top"> 
        //     <div className="col-md-4 d-flex align-items-center"> 
        //         © 2025 Hospitales MAC
        //     </div> 
        //     <ul className="nav col-md-4 justify-content-end list-unstyled d-flex"> 
        //         <li className="ms-3">
        //             <a className="text-body-secondary" href="#" aria-label="Instagram"></a>
        //         </li>
        //         <li className="ms-3">
        //             <a className="text-body-secondary" href="#" aria-label="Facebook"></a>
        //         </li> 
        //     </ul> 
        // </footer>
        <footer className="bg-dark text-white py-3 mt-auto">
            <div className="container text-center">
                <p className="mb-1">© 2025 Hospitales Mac Todos los derechos reservados.</p>
            </div>
        </footer>
    );
}

export default PiePagina;